<template>
  <div>
    <BlFlexContainerMv direction="column" padding="16px" class="border-bottom-gray">
      <div v-html="description"></div>
    </BlFlexContainerMv>

    <BlAccordionMv id="facility" :is-active="true">
      <template #header>
        <BlTextAv variation="body-14" tag="h2" weight="bold">Fasilitas {{ merchantName }}</BlTextAv>
      </template>
      <template #content>
        <div v-html="facility"></div>
      </template>
    </BlAccordionMv>

    <BlAccordionMv id="tnc">
      <template #header>
        <BlTextAv variation="body-14" tag="h2" weight="bold">Syarat & Ketentuan {{ merchantName }}</BlTextAv>
      </template>
      <template #content>
        <div v-html="termsAndCondition"></div>
      </template>
    </BlAccordionMv>
    <BlAccordionMv id="contact">
      <template #header>
        <BlTextAv variation="body-14" tag="h2" weight="bold">Kontak {{ merchantName }}</BlTextAv>
      </template>
      <template #content>
        <div v-html="contact"></div>
      </template>
    </BlAccordionMv>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import sanitizeHtml from 'sanitize-html';
import {BlAccordionMv} from '@bukalapak/bazaar-mweb-latest';

export default {
  name: 'PrakerjaMerchantProfile',
  components: {BlAccordionMv},

  computed: {
    ...mapGetters({
      merchantDetail: 'merchants/getMerchantDetail',
    }),
    description() {
      return sanitizeHtml(this.merchantDetail.description);
    },
    facility() {
      return sanitizeHtml(this.merchantDetail.facility);
    },
    termsAndCondition() {
      return sanitizeHtml(this.merchantDetail.terms_condition);
    },
    contact() {
      return sanitizeHtml(this.merchantDetail.contact);
    },
    merchantName() {
      return this.merchantDetail.name;
    }
  },
};
</script>
